import React, { useEffect, useState } from "react";
import DetalleEnvioService from "services/DetalleEnvioService";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Document } from "react-pdf";
import { useAtom } from "jotai";
import PaginaPdf from "./PaginaPdf";
import BarraHerramientas from "./BarraHerramientas";
import { Alert, message } from "antd";
import {
	formularioSeleccionadoAtom,
	loadingPdfAtom,
	permiteGuardarAvanceAtom,
	visibleVisorFormularioAtom,
	urlFirmaHolografaAtom,
	urlFotoAtom,
	urlHuellaDactilarAtom
} from "pages/consultar/bandeja-tareas/store/Store";

export function Body({ control }) {
	const [formularioSeleccionado] = useAtom(formularioSeleccionadoAtom);
	const [totalPaginas, setTotalPaginas] = useState(undefined);
	const [urlPdf, setUrlPdf] = useState(undefined);
	const [componentes, setComponentes] = useState(undefined);
	const [variablesFormulario, setVariablesFormulario] = useState(undefined);
	const [parametrosFormulario, setParametrosFormulario] = useState(undefined);
	const [datosFormulario, setDatosFormulario] = useState(undefined);
	const [loading, setLoading] = useState(false);

	const [, setUrlFirmaHolografa] = useAtom(urlFirmaHolografaAtom);
	const [, setUrlHuellaDacilar] = useAtom(urlHuellaDactilarAtom);
	const [, setUrlFoto] = useAtom(urlFotoAtom);
	const [, setLoadingPdf] = useAtom(loadingPdfAtom);
	const [, setPermiteGuardarAvance] = useAtom(permiteGuardarAvanceAtom);
	const [, setVisibleVisorFormulario] = useAtom(visibleVisorFormularioAtom);

	useEffect(() => {
		const obtenerUrlPlantillaPdf = async () => {
			if (!formularioSeleccionado) {
				return;
			}

			setLoading(true);

			try {
				const respuesta = await DetalleEnvioService.obtenerDatosFormularioAdministrador(formularioSeleccionado.id);

				setUrlPdf(respuesta.urlPlantillaPdfFirmada);
				setComponentes(respuesta.componentes);
				setVariablesFormulario(respuesta.variablesFormulario);
				setParametrosFormulario(respuesta.parametrosFormulario);
				setDatosFormulario(respuesta.datosFormulario);
				setPermiteGuardarAvance(respuesta.permiteGuardarAvance === true);
				if (respuesta.urlFirmaHolografa !== undefined) {
					setUrlFirmaHolografa(respuesta.urlFirmaHolografa);
				}
				if (respuesta.urlHuellaDactilar !== undefined) {
					setUrlHuellaDacilar(respuesta.urlHuellaDactilar);
				}
				if (respuesta.urlFoto !== undefined) {
					setUrlFoto(respuesta.urlFoto);
				}
			} catch (error) {
				setLoading(false);
				message.error(error?.response?.data?.mensaje || "No se pudo cargar el documento.");
				setVisibleVisorFormulario(false);
			}
		};
		obtenerUrlPlantillaPdf();
	}, [formularioSeleccionado]);

	const onLoadSuccess = async (successEvent) => {
		setTotalPaginas(successEvent.numPages);
		setLoading(false);
		setLoadingPdf(false);
	};

	return (
		<div
			style={{
				height: formularioSeleccionado?.motivoRechazo ? "calc(90% - 64px)" : "calc(100% - 64px)",
			}}
		>
			{loading && (
				<div className="visor-formulario-loading">
					<Loading3QuartersOutlined spin className="loading" />
				</div>
			)}
			<BarraHerramientas />
			{!!formularioSeleccionado?.motivoRechazo && (
				<div style={{ zIndex: 0 }}>
					<Alert
						message="Formulario Rechazado"
						description={"Motivo de Rechazo : " + formularioSeleccionado?.motivoRechazo}
						type="warning"
						showIcon
					//closable
					/>
				</div>
			)}
			<div className="visor-formulario-body">
				<Document file={urlPdf} onLoadSuccess={onLoadSuccess} loading={null}>
					{Array.from(new Array(totalPaginas), (el, index) => (
						<PaginaPdf
							key={`page_${index + 1}`}
							numeroPagina={index + 1}
							componentes={componentes}
							variablesFormulario={variablesFormulario}
							datosFormulario={datosFormulario}
							parametrosFormulario={parametrosFormulario}
							control={control}
						/>
					))}
				</Document>
			</div>
		</div>
	);
}
